import DashboardDuck from '@aytm/app/insights/dashboard/duckness/ducks/DashboardDuck/DashboardDuck'
import { DASHBOARD_ACTIONS } from '@aytm/app/insights/dashboard/duckness/ducks/DashboardDuck/DashboardDuck.actions'
import type { DuckActionPayloadTuple } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import { SendStatus, type SendStatusType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

export const makeUpdateTitleDashboardAction = (newTitle: string, oldTitle: string) =>
  [
    DashboardDuck.duckName,
    DASHBOARD_ACTIONS.UPDATE_TITLE,
    {
      title: newTitle,
      oldTitle
    }
  ] as DuckActionPayloadTuple<object>

export const makeSendSourceRequestDashboardAction = (input: object, _surveys?: unknown) =>
  [
    DashboardDuck.duckName,
    DASHBOARD_ACTIONS.SEND_SOURCE,
    {
      object: input
      // surveys
    }
  ] as DuckActionPayloadTuple<{ object: object; surveys: unknown }>

export const makeSendSchemaRequestDashboardAction = (input: object, _surveys?: unknown) =>
  [
    DashboardDuck.duckName,
    DASHBOARD_ACTIONS.SEND_SCHEMA,
    {
      object: input
      // surveys
    }
  ] as DuckActionPayloadTuple<{ object: object; surveys: unknown }>

export const makeUpdateDashboardDashboardAction = (update: unknown) =>
  [DashboardDuck.duckName, DASHBOARD_ACTIONS.UPDATE_DASHBOARD, update] as DuckActionPayloadTuple<unknown>

export const makeClonePortalDashboardAction = (title: string = 'Insights') =>
  [DashboardDuck.duckName, DASHBOARD_ACTIONS.CLONE_PORTAL, { title }] as DuckActionPayloadTuple<{ title: string }>

export const makeRequestShareDialogDashboardAction = (reportId: string) =>
  [DashboardDuck.duckName, DASHBOARD_ACTIONS.REQUEST_SHARE_UI, reportId] as DuckActionPayloadTuple<string>

export const makeDismissShareDialogDashboardAction = () =>
  [DashboardDuck.duckName, DASHBOARD_ACTIONS.REQUEST_SHARE_UI] as DuckActionPayloadTuple

export const makeRequestShareURLDashboardAction = (reportId: string) =>
  [DashboardDuck.duckName, DASHBOARD_ACTIONS.REQUEST_SHARE_URL, reportId] as DuckActionPayloadTuple<string>

export const makeSendInvitationResetStatusDashboardAction = () =>
  [
    DashboardDuck.duckName,
    DASHBOARD_ACTIONS.SEND_INVITATION,
    {
      sendStatus: SendStatus.Send
    }
  ] as DuckActionPayloadTuple<{ sendStatus: SendStatusType }>

export const makeSendInvitationForEmailDashboardAction = (email: string | string[], sharedKey: string) =>
  [DashboardDuck.duckName, DASHBOARD_ACTIONS.SEND_INVITATION, { sharedKey, email }] as DuckActionPayloadTuple<{
    email: string | string[]
    sharedKey: string
  }>
